import * as React from "react";
const SvgShowPasswordIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} stroke="#A1ACC3" viewBox="0 0 16 16" {...props}><path d="M22.008 12.469S17.53 6 12.006 6 1.998 12.469 1.998 12.469s4.482 6.469 10.008 6.469 10.002-6.47 10.002-6.47m0 0" style={{
    fill: "none",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }} transform="scale(.66667)" /><path d="M12.006 16.47a4 4 0 0 0 4.002-4.001 4.004 4.004 0 0 0-4.002-4.002 4 4 0 0 0-4.002 4.002 3.996 3.996 0 0 0 4.002 4.002m0 0" style={{
    fill: "none",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }} transform="scale(.66667)" /></svg>;
export { SvgShowPasswordIcon as ReactComponent };